import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { AdminDashboardService } from './admin-dashboard.service';

angular.module('app-lite.admin-dashboard', [])
  .service('adminDashboardApi', downgradeInjectable(AdminDashboardService));